import styled from 'styled-components'

export const PricingHeader = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  svg {
    cursor: pointer;
  }
`

export const InfoSection = styled.div`
  display: flex;
  justify-content: center;
  padding: 2.5rem 0;
  gap: 1rem;
  max-width: 1060px;
  margin: 0 auto;

  h2 {
    font-size: 2.25rem;
    margin-bottom: 2.5rem;
  }

  p {
    font-size: 1.125rem;
    color: #4d4f52;
    font-weight: 600;
  }

  span {
    color: #41a6dc;
  }

  @media (max-width: 980px) {
    flex-direction: column;
    align-items: center;
  }
`

export const InfoTextWrapper = styled.div`
  flex: 1;
`

export const InfoImgWrapper = styled.div`
  @media (min-width: 980px) {
    width: 35%;
  }
  img,
  svg {
    min-width: 250px;
    max-width: 300px;
  }
`

export const ContentWrapper = styled.div`
  padding: 0.5rem 0 1.5rem 0;
  max-width: 1060px;
  margin: 2rem auto 0;
`

export const PriceTableWrapperMessage = styled.div`
  margin: 1rem auto 1.5rem auto;
  width: 87%;
  //margin: 1.5rem auto;
  background: #fff;
  box-shadow: -2px 0px 5px 0 rgb(44 44 44 / 14%);
  border: 2px solid #e9e9e9;
  padding: 0.5rem 1rem;
  border-left: 18px solid ${({ theme }) => theme.brand.primary.background};
  border-radius: 10px;
`
export const PriceTableWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  // gap: 1.5rem;

  @media (max-width: 800px) {
    flex-direction: column;
  }
`

export const InputWrapperIcon = styled.div`
  position: relative;
  svg {
    position: absolute;
    top: 50%;
    right: 5%;
    transform: translateY(-50%);
  }

  .tooltip-style {
    width: 20rem;
  }
`

export const ContactSectionTitle = styled.label`
  font-weight: 600;
  font-size: 1em;
`
export const ContactSectionText = styled.p`
  font-size: 1em;
`
export const ContactSectionWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  margin-left: 1em;
  flex: 1;
  @media screen and (max-width: 980px) {
    margin-left: 0;
  }
`
export const ContactSection = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 100%;
  padding: 1rem;
  background: rgba(65, 166, 220, 0.07);
  border-radius: 8px;
  margin: 2rem 0;
  @media screen and (max-width: 980px) {
    align-items: flex-start;
  }

  button {
    display: block;
    font-size: 1em;
  }

  @media (max-width: 800px) {
    flex-direction: column;
    gap: 1rem;
    div {
      flex-direction: column;
      gap: 1rem;
      margin-bottom: 1rem;
    }
  }
`
